(() => {
  'use strict';
  const audienceOf = root => {
    const values = [...root.querySelectorAll('[data-neb-option-name]:not([data-neb-option-name*="size"]) [data-ct-option]:checked')].map(input => input.value).join(' ').toLowerCase();
    const text = values || root.querySelector('h1')?.textContent.toLowerCase() || '';
    if (/women|woman|female|ladies/.test(text)) return 'women';
    if (/youth|kids|children|junior/.test(text)) return 'youth';
    return 'men';
  };
  const normalizeSize = value => String(value || '').toUpperCase().replace(/^YTH\s*/,'').replace(/\s+/g,'').replace(/^XXXL$/,'3XL').replace(/^XXL$/,'2XL').replace(/^XXXXL$/,'4XL').replace(/^Y(?=XS$|S$|M$|L$|XL$|2XL$)/,'');
  const selectedSize = root => root.querySelector('[data-neb-option-name*="size"] [data-ct-option]:checked')?.value || '';
  const unlock = () => { if (!document.querySelector('.neb-size-dialog[open]')) document.documentElement.classList.remove('neb-size-open'); };
  const refreshScrollHint = dialog => {
    const hint = dialog.querySelector('[data-guide-scroll-hint]');
    if (hint) hint.hidden = ![...dialog.querySelectorAll('[data-guide-audience]:not([hidden]) .neb-size-guide__table-wrap')].some(wrap => wrap.scrollWidth > wrap.clientWidth + 1);
  };
  window.addEventListener('resize',() => document.querySelectorAll('.neb-size-dialog[open]').forEach(refreshScrollHint),{passive:true});
  const init = fallback => {
    if (fallback.dataset.guideReady) return;
    const root = fallback.closest('[data-ct-product]');
    if (!root || !window.HTMLDialogElement) return;
    fallback.dataset.guideReady = 'true';
    const content = fallback.querySelector('.neb-size-guide__content');
    const strings = JSON.parse(content.querySelector('[data-guide-strings]').textContent);
    const dialog = document.createElement('dialog');
    dialog.className = 'neb-size-dialog';
    dialog.id = content.id.replace('neb-size-guide-','neb-size-dialog-');
    dialog.setAttribute('aria-labelledby',content.id + '-title');
    dialog.setAttribute('aria-modal','true');
    const sportSelect = content.querySelector('[data-guide-sport-select]');
    const panels = [...content.querySelectorAll('[data-guide-audience]')];
    const tabs = [...content.querySelectorAll('[data-guide-tab]')];
    const unitButtons = [...content.querySelectorAll('[data-guide-unit]')];
    const selection = content.querySelector('[data-guide-selection]');
    const empty = content.querySelector('[data-guide-empty]');
    const footnote = content.querySelector('.neb-size-guide__footnote');
    let sport = fallback.dataset.guideSport;
    let audience = audienceOf(root);
    let unit = 'in';
    let trigger;
    try { if (localStorage.getItem('neb-size-guide-unit') === 'cm') unit = 'cm'; } catch (_) {}
    const format = new Intl.NumberFormat(document.documentElement.lang || 'en',{maximumFractionDigits:1});
    const paintUnit = () => {
      content.querySelectorAll('[data-guide-inches]').forEach(cell => {
        cell.textContent = unit === 'in' ? cell.dataset.guideInches : cell.dataset.guideInches.split('–').map(value => format.format(Number(value) * 2.54)).join('–');
      });
      content.querySelectorAll('[data-guide-unit-label]').forEach(label => { label.textContent = unit === 'in' ? '(in)' : '(cm)'; });
      unitButtons.forEach(button => button.setAttribute('aria-pressed',String(button.dataset.guideUnit === unit)));
      requestAnimationFrame(() => { if (dialog.isConnected) refreshScrollHint(dialog); });
    };
    const paint = () => {
      const size = selectedSize(root);
      const sameAudience = audience === audienceOf(root);
      let matched = false;
      panels.forEach(panel => {
        panel.hidden = panel.dataset.guideSport !== sport || panel.dataset.guideAudience !== audience;
        panel.setAttribute('role','tabpanel');
        panel.setAttribute('aria-labelledby',content.id + '-tab-' + panel.dataset.guideAudience);
        panel.querySelectorAll('[data-guide-size]').forEach(row => {
          const selected = !panel.hidden && sameAudience && size && row.dataset.guideSize.split('|').some(value => normalizeSize(value) === normalizeSize(size));
          row.classList.toggle('is-selected',Boolean(selected));
          if (selected) { row.setAttribute('aria-current','true'); matched = true; }
          else row.removeAttribute('aria-current');
        });
      });
      tabs.forEach(button => {
        const active = button.dataset.guideTab === audience;
        button.setAttribute('aria-selected',String(active));
        button.tabIndex = active ? 0 : -1;
        button.disabled = !sport;
        if (sport) button.setAttribute('aria-controls',content.id + '-' + sport + '-' + button.dataset.guideTab);
        else button.removeAttribute('aria-controls');
      });
      content.querySelectorAll('.neb-size-guide__fallback-heading').forEach(heading => { heading.hidden = true; });
      empty.hidden = Boolean(sport);
      selection.hidden = !sport || !size || !sameAudience;
      selection.textContent = sport && size && sameAudience ? (matched ? strings.selected : strings.missing).replace('__SIZE__',size) : '';
      selection.classList.toggle('is-missing',Boolean(sport && size && sameAudience && !matched));
      footnote.textContent = sport === 'soccer' ? strings.reference : strings.tolerance;
      footnote.hidden = !sport;
      paintUnit();
    };
    dialog.append(content);
    fallback.replaceWith(dialog);
    dialog.addEventListener('close',() => { unlock(); if (trigger?.isConnected) trigger.focus({preventScroll:true}); });
    dialog.addEventListener('click',event => {
      const close = event.target.closest('[data-guide-close]');
      if (close) { dialog.close(); return; }
      if (event.target === dialog) {
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      }
      const tab = event.target.closest('[data-guide-tab]');
      if (tab) { audience = tab.dataset.guideTab; paint(); }
      const unitButton = event.target.closest('[data-guide-unit]');
      if (unitButton) { unit = unitButton.dataset.guideUnit; paintUnit(); try { localStorage.setItem('neb-size-guide-unit',unit); } catch (_) {} }
    });
    content.querySelector('[role="tablist"]').addEventListener('keydown',event => {
      const current = event.target.closest('[data-guide-tab]');
      if (!current || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      let index = tabs.indexOf(current);
      index = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowLeft' ? -1 : 1) + tabs.length) % tabs.length;
      audience = tabs[index].dataset.guideTab;
      paint();tabs[index].focus();
    });
    sportSelect?.addEventListener('change',() => { sport = sportSelect.value; paint(); });
    root.querySelectorAll('[data-neb-size-open]').forEach(link => {
      link.addEventListener('click',event => {
        event.preventDefault();trigger = link;audience = audienceOf(root);paint();
        if (!dialog.open) dialog.showModal();
        document.documentElement.classList.add('neb-size-open');
        content.querySelector('.neb-size-guide__body').scrollTop = 0;
      });
    });
    paint();
  };
  const initAll = () => { document.querySelectorAll('[data-neb-size-guide]').forEach(init); unlock(); };
  initAll();
  document.addEventListener('ct:variant-changed',initAll);
  document.addEventListener('shopify:section:load',initAll);
  document.addEventListener('shopify:section:unload',unlock);
})();
